<script lang="ts" src="./SubmitButton.ts"></script>


<template>
  <m-button
    :appearance="$const.StyleAppearance.DARK"
    :disabled="disabled"
    :iconAfter="iconAfter"
    :iconBefore="isForm ? {name: 'floppy-disk', solid: true, type: $const.IconTypes.FONT_AWESOME, } : iconBefore"
    :isSubmit="true"
    :size="size"
    @click="submit()"
  >
    {{ $trans.t(label) }}
  </m-button>
</template>


<style lang="scss" scoped>
</style>
